var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRisk = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#D11F00",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7974 17.9066C21.3742 18.8815 20.6502 20.1 19.4981 20.1H4.5017C3.34742 20.1 2.62673 18.8796 3.20242 17.9066L10.7007 5.23079C11.2778 4.25552 12.7232 4.25729 13.2993 5.23079L20.7974 17.9066Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5625 16.6883C10.5625 15.9142 11.2061 15.2867 12 15.2867C12.7939 15.2867 13.4375 15.9142 13.4375 16.6883C13.4375 17.4623 12.7939 18.0898 12 18.0898C11.2061 18.0898 10.5625 17.4623 10.5625 16.6883Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.867 14.3926L10.6352 10.2488C10.6235 10.0394 10.7945 9.86328 11.0096 9.86328H12.9903C13.2055 9.86328 13.3765 10.0394 13.3648 10.2488L13.133 14.3926C13.1221 14.5865 12.9577 14.7383 12.7585 14.7383H11.2415C11.0423 14.7383 10.8779 14.5865 10.867 14.3926Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRisk);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Risk.3e65e7296509be59560f8bee3b42cd1c.svg";